/** True when offence includes populated step bodies (not a slim list row). */
export function guidanceOffenceHasFullSteps(offence) {
  if (!offence) return false;
  return (offence.guidance_steps || []).some(
    (step) =>
      step &&
      (step.title ||
        (Array.isArray(step.guidance_step_description) &&
          step.guidance_step_description.length > 0))
  );
}
